import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import { ContentProvider } from "./context/ContentContext";
import { LanguageProvider } from "./context/LanguageContext";
import { Layout } from "./components/Layout";
import { AnalyticsTracker } from "./lib/analytics";
import Landing from "./pages/Landing";
import Home from "./pages/Home";
import Product from "./pages/Product";
import CartPage from "./pages/CartPage";
import Formule from "./pages/Formule";
import Marque from "./pages/Marque";
import Rituel from "./pages/Rituel";
import FaqPage from "./pages/FaqPage";
import Contact from "./pages/Contact";
import Auth from "./pages/Auth";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import Coffrets from "./pages/Coffrets";
import Legal from "./pages/Legal";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import PayPalResult from "./pages/PayPalResult";

function UniverseHome({ u }) {
  const { setUniverse } = useTheme();
  useEffect(() => { setUniverse(u); }, [u, setUniverse]);
  return <Home />;
}

function Shell() {
  return <Layout><Outlet /></Layout>;
}

function App() {
  return (
    <ThemeProvider>
      <ContentProvider>
        <LanguageProvider>
          <AuthProvider>
            <CartProvider>
              <BrowserRouter>
                <AnalyticsTracker />
                <Routes>
                  <Route path="/" element={<Landing />} />
                  <Route element={<Shell />}>
                    <Route path="/femme" element={<UniverseHome u="femme" />} />
                    <Route path="/homme" element={<UniverseHome u="homme" />} />
                    <Route path="/coffrets" element={<Coffrets />} />
                    <Route path="/serum" element={<Product />} />
                    <Route path="/serum-femme" element={<Product fixedUniverse="femme" />} />
                    <Route path="/serum-homme" element={<Product fixedUniverse="homme" />} />
                    <Route path="/formule" element={<Formule />} />
                    <Route path="/marque" element={<Marque />} />
                    <Route path="/rituel" element={<Rituel />} />
                    <Route path="/faq" element={<FaqPage />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/panier" element={<CartPage />} />
                    <Route path="/connexion" element={<Auth mode="login" />} />
                    <Route path="/inscription" element={<Auth mode="register" />} />
                    <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
                    <Route path="/reinitialiser-mot-de-passe" element={<ResetPassword />} />
                    <Route path="/compte" element={<Account />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/legal/:slug" element={<Legal />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/payment/cancel" element={<PaymentCancel />} />
                    <Route path="/payment/paypal/success" element={<PayPalResult />} />
                    <Route path="/payment/paypal/cancel" element={<PaymentCancel />} />
                  </Route>
                </Routes>
              </BrowserRouter>
              <Toaster position="bottom-center" theme="dark" />
            </CartProvider>
          </AuthProvider>
        </LanguageProvider>
      </ContentProvider>
    </ThemeProvider>
  );
}

export default App;
